import React, {Component} from 'react';
import { login } from 'actions/userActions';
import { connect } from 'react-redux';
import * as settings from 'settings/settings';
import * as cookieServices from 'services/cookies/cookieServices';
import {saveApplication} from 'actions/appDataActions';
import LoginForm from 'components/login/LoginForm';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ThemeDefault from 'layouts/material-admin/theme-default';
import * as redirectServices from 'services/url/redirectServices';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

class LoginPage extends Component{

  constructor(props) {
    super(props);
    /*
        carico le chiavi di CalAmp defintie nel settings
    */
    var calAmpKeys = settings.ApplicationKeyList;

    const calAmpKeysFormattedForDropDown = calAmpKeys.map(key => {
        return {
            id: key.id,
            value: key.baseUri,
            text: key.name
        };
    });

    var selectedApp = null;
    var selectedAppId = null;

    if(calAmpKeys && calAmpKeys.length === 1)
    {
      selectedApp = calAmpKeys[0]
      selectedAppId = selectedApp.id;
      /*
        devo salvare subito queste info nel cookie che verranno lette dai servizi http
      */
      console.info("setting initial app");
      cookieServices.saveApplication(selectedApp);
      //this.props.saveApplication(selectedApp);
    }

    this.state = {
        formData: {
            username: '',
            password: '',
            calAmpKeys: calAmpKeys,
            formattedAmpKeys: calAmpKeysFormattedForDropDown,
            selectedAppId: selectedAppId,
            selectedApp: selectedApp,
            isCalAmpListVisible: calAmpKeys != null && calAmpKeys.length > 1
        },
        isAuthenticating: props.user.isAuthenticating,
        authError: null,
        isAuthenticated: props.user.isAuthenticated
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleListChange = this.handleListChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  /**
     * per gestire errori di autentizazione.
     * viene scatenato da connect e solo se è statyo definito il mapStateToProps.
     * newProps contiene le nuove proprietà mappate in mapStateToProps
     * @param {*} newProps
    //  */
  componentWillReceiveProps(newProps) {

      this.setState({
        isAuthenticating: newProps.user.isAuthenticating,
        authError: newProps.user.authError,
        isAuthenticated: newProps.user.isAuthenticated
      });

      /*
        se l'utente è già autenticato è inutile rimanere nella
        pagina di login
      */
      if(newProps.user.isAuthenticated === true){
        redirectServices.redirectTo();
      }
  }

  handleLogin = (e) => {
    e.preventDefault()

    this.setState({ isAuthenticating: true }, () => {

      this.props.login({
        username: this.state.formData.username,
        password: this.state.formData.password,
        selectedApp: this.state.formData.selectedApp
      })
    });
  };

  /**
   * per gestire i valori degli input testuali
   * @param {evento input testuale} event
   */
  handleChange(event) {
      const { formData } = this.state;
      formData[event.target.name] = event.target.value;
      this.setState({ formData });
  }

  /**
   * per gestire il selectedValue del SelectItem
   * @param {} event
   * @param {*} index
   * @param {*} response
   */
  handleListChange(event, index, response) {
    /*
      response = id del api key di settings.ApplicationKeyList
    */
    const selected = this.state.formData.calAmpKeys.filter(x => x.id === response);
    const { formData } = this.state;
    formData.selectedAppId = response;
    formData.selectedApp = selected[0];
    this.setState({ formData });
  }

  render() {
      const { formData, isAuthenticating } = this.state;
      const {translate} = this.props;
      return (
        <MuiThemeProvider muiTheme={ThemeDefault}>
          <LoginForm formData={formData}
            isAuthenticating={isAuthenticating}
            handleLogin={this.handleLogin}
            handleListChange={this.handleListChange}
            handleChange={this.handleChange}
            translate={translate}
          />
        </MuiThemeProvider>
      );
  }

}

function mapStateToProps(state, ownProps){
  return {
    user: {
      isAuthenticating: state.user.isAuthenticating,
      isAuthenticated: state.user.isAuthenticated,
      authError: state.user.authError
    },
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code
  }
}

export default connect(mapStateToProps, { login, saveApplication })(LoginPage);




// WEBPACK FOOTER //
// ./src/pages/login/LoginPage.js